import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap, mergeMap } from 'rxjs/operators';
import * as catalog from '@webapp/sdk/catalog';
import { Actions } from '../../actions';
import {
  GetCatalog,
  CreateCombinedCatalog,
  GetCatalogSuccess,
  GetCatalogError,
} from '../action-creators';
import { GET_CATALOG } from '../actions';
import { Action } from 'redux';

export const getCatalogEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, GetCatalog>(GET_CATALOG),
    mergeMap(async (action) => {
      try {
        const catalogList = await catalog.list(action.params);

        let result: Action[] = [
          new GetCatalogSuccess(
            action.params.type || 'OWNER',
            catalogList,
            !!action.params.nextToken
          ),
        ];

        if (
          catalogList.nextToken &&
          catalogList.nextToken !== action.params.nextToken
        ) {
          result = result.concat([
            new GetCatalog({
              ...action.params,
              nextToken: catalogList.nextToken,
            }),
          ]);
        }

        if (!catalogList.nextToken) {
          result = result.concat([new CreateCombinedCatalog()]);
        }

        return result;
      } catch (err) {
        return [new GetCatalogError(err.message)];
      }
    }),
    concatMap((actions) => actions)
  );
